import React from 'react'
import cx from 'classnames'

import styles from './ListItem.module.scss'

type ListItemProps = {
  children?: React.ReactNode
  className?: string
}

export const ListItem = React.forwardRef<HTMLLIElement, ListItemProps>(
  ({ children, className }, ref) => (
    <li className={cx(styles.item, className)} {...{ ref }}>
      {children}
    </li>
  ),
)
